
import React from 'react'
import Image from 'next/image'
import { LOGO_STANDARDS, ProjectStandardType } from 'src/core/models'
import { LOGO_STANDARD_IMAGES } from 'src/assets/images/logoStandards'
import styles from './ProjectDetailsLogoStandard.module.scss'

const STANDARD_IMAGE_MAP = {
  [LOGO_STANDARDS.ACR]: LOGO_STANDARD_IMAGES.ACR,
  [LOGO_STANDARDS.ARTTREES]: LOGO_STANDARD_IMAGES.ARTTREES,
  [LOGO_STANDARDS.BCR]: LOGO_STANDARD_IMAGES.BCR,
  [LOGO_STANDARDS.CAR]: LOGO_STANDARD_IMAGES.CAR,
  [LOGO_STANDARDS.CDM]: LOGO_STANDARD_IMAGES.CDM,
  [LOGO_STANDARDS.CERCARBONO]: LOGO_STANDARD_IMAGES.CERCARBONO,
  [LOGO_STANDARDS.GCC]: LOGO_STANDARD_IMAGES.GCC,
  [LOGO_STANDARDS.GOLD]: LOGO_STANDARD_IMAGES.GOLD,
  [LOGO_STANDARDS.ICR]: LOGO_STANDARD_IMAGES.ICR,
  [LOGO_STANDARDS.IREC]: LOGO_STANDARD_IMAGES.IREC,
  [LOGO_STANDARDS.LCL]: LOGO_STANDARD_IMAGES.LCL,
  [LOGO_STANDARDS.MITECO]: LOGO_STANDARD_IMAGES.MITECO,
  [LOGO_STANDARDS.PLANVIVO]: LOGO_STANDARD_IMAGES.PLANVIVO,
  [LOGO_STANDARDS.PURO]: LOGO_STANDARD_IMAGES.PURO,
  [LOGO_STANDARDS.UKWOODLAND]: LOGO_STANDARD_IMAGES.UKWOODLAND,
  [LOGO_STANDARDS.VCS]: LOGO_STANDARD_IMAGES.VCS
}

const ProjectDetailsLogoStandard: React.FC<{ standard: ProjectStandardType | string }> = ({ standard }) => {
  const getStandardImage = () => STANDARD_IMAGE_MAP[standard]
  return (
    <div className={styles.imageContent}>
      <Image
        src={getStandardImage()}
        alt={`logo-${standard}`}
        className={styles.image}
      />
    </div>
  )
}

export default ProjectDetailsLogoStandard
